import { render, staticRenderFns } from "./StudentPurchaseHistory.vue?vue&type=template&id=1fca7057&scoped=true&"
import script from "./StudentPurchaseHistory.vue?vue&type=script&lang=ts&"
export * from "./StudentPurchaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPurchaseHistory.vue?vue&type=style&index=0&id=1fca7057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca7057",
  null
  
)

export default component.exports